export function getSchoolRankingLabel(input: {
  excludeFromOfficialMetrics?: boolean
  schoolRanking?: number | null
}) {
  if (input.excludeFromOfficialMetrics) {
    return 'Fora do ranking oficial'
  }

  if (input.schoolRanking != null) {
    return `${input.schoolRanking}º Lugar`
  }

  return 'Sem ranking'
}
